import React, { useState } from "react";
import "./styles.css";
import DSRefundHomepage from "./DSRefundHomepage";
import DSRefundRequest from "./DSRefundRequest";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { postData } from "../../Hooks/apiCalls";
import { isDevelopment } from "../../Hooks/constants";
const DSRefund = () => {
  // variables
  const domain_id = Cookies.get("ssp_domain_id");
  const ssp_role = Cookies.get("ssp_role");
  const [createRequest, setCreateRequest] = useState(false);
  const [allRefundDetailsLoader, setAllRefundDetailsLoader] = useState(false);
  const [allRefundData, setAllRefundData] = useState([]);

  const handleOpenCreateRequest = () => {
    setCreateRequest(true);
  };

  const handleCloseCreateRequest = () => {
    setCreateRequest(false);
  };

  // API call
  const getAllRefundDetailsApi = async () => {
    const payload = {
      domain_id: domain_id,
      role: ssp_role === "21" ? "store" : ssp_role === "18" && "finance",
    };
    setAllRefundDetailsLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }get_all_refund_details`,
        true,
        false,
        payload
      );
      const response = data?.body;
      if (response?.status === "success") {
        setAllRefundData(response?.data);
        setAllRefundDetailsLoader(false);
      } else {
        setAllRefundDetailsLoader(false);
        toast.error(response?.message, { autoClose: 1500 });
      }
    } catch (err) {
      setAllRefundDetailsLoader(false);
      console.log(err);
    }
  };

  return (
    <div className="main">
      {/* Homepage  */}
      <DSRefundHomepage
        handleOpenCreateRequest={handleOpenCreateRequest}
        allRefundData={allRefundData}
        allRefundDetailsLoader={allRefundDetailsLoader}
        getAllRefundDetailsApi={getAllRefundDetailsApi}
      />
      <DSRefundRequest
        open={createRequest}
        handleClose={handleCloseCreateRequest}
        getAllRefundDetailsApi={getAllRefundDetailsApi}
      />
    </div>
  );
};

export default DSRefund;
